<template>
    <script type="text/x-template" id="template-LMT" class="template">
        <li class="block edit_block LMT-block adjustment-block">
            <div class="header-container edit_block_header drag_handle">
                <label class="lookup_block_name name">LMT</label>
            </div>
        </li>
    </script>
</template>
<script>

export default {};
</script>

<style></style>
